import { UserModel, ContactViewModel, ContactModel } from "@/Domains";
import {
    Header,
    FaBuilding,
    FaCalendar,
    FaDollarSign,
    FaHashtag,
    FaUser,
    FaUserTag,
    AppEnum,
    OptionHelper,
    LeaseEnums,
    FaFileInvoice,
    FaFileInvoiceDollar,
} from "@/Shared";

import { LeaseViewModel } from "./ViewModels/LeaseViewModel";

export class LeaseHeader {

    private constructor() { }

    getId() {
        return {
            key: 'id',
            icon: <FaHashtag />,
            label: 'ID',
            type: 'number',
            isSortable: true
        };
    }

    getLeaseType(leaseTypes: AppEnum[]) {
        return {
            key: 'leaseType',
            icon: <FaFileInvoiceDollar />,
            label: 'Type de lease',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Type de lease",
                options: leaseTypes,
                case: 'sensitive'
            }
        };
    }

    getLeaseStart() {
        return {
            key: 'leaseStart',
            icon: <FaCalendar />,
            label: 'Début lease',
            type: 'date',
            isSortable: true
        };
    }

    getLeaseEnd() {
        return {
            key: 'leaseEnd',
            icon: <FaCalendar />,
            label: 'Fin lease',
            type: 'date',
            isSortable: true
        };
    }

    getRevisionRate() {
        return {
            key: 'revisionRate',
            icon: <FaFileInvoiceDollar />,
            label: 'Taux rév. (%)',
            type: 'number',
            isSortable: true
        };
    }

    getRevisionFrequency() {
        return {
            key: 'revisionFrequency',
            icon: <FaDollarSign />,
            label: 'Fréquence rév.',
            type: 'string',
            isSortable: true
        };
    }

    getTransaction() {
        return {
            key: 'transactionId',
            icon: <FaFileInvoice />,
            label: 'Transaction',
            type: 'number',
            isSortable: true
        };
    }

    static build(
        viewEnums: LeaseEnums
    ): Record<keyof LeaseViewModel, Header<LeaseViewModel>> {

        const header = new LeaseHeader();

        return {
            id: header.getId(),
            leaseType: header.getLeaseType(viewEnums.LeaseTypeEnum),
            leaseStart: header.getLeaseStart(),
            leaseEnd: header.getLeaseEnd(),
            revisionRate: header.getRevisionRate(),
            revisionFrequency: header.getRevisionFrequency(),
            transactionId: header.getTransaction()
        } as Record<keyof LeaseViewModel, Header<LeaseViewModel>>;
    }

    getPropertyId() {
        return {
            key: 'propertyId',
            icon: <FaBuilding />,
            label: 'Bien',
            type: 'number',
            isSortable: true
        };
    }

    getOwner(contactList: ContactModel[]) {
        return {
            key: 'owner',
            icon: <FaUserTag />,
            label: 'Proprio',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Propriétaire",
                options: OptionHelper.ownerOptions(contactList),
                case: 'sensitive'
            }
        };
    }

    getAdvisor(agents: UserModel[]) {
        return {
            key: 'advisor',
            icon: <FaUser />,
            label: 'Conseillé',
            type: 'string',
            isSortable: true,
            filter: {
                label: "Conseillé",
                case: 'sensitive',
                options: OptionHelper.userOptions(agents)
            }
        };
    }

    getAgencyCom() {
        return {
            key: 'agencyCom',
            icon: <FaDollarSign />,
            label: 'Honoraires',
            type: 'number',
            isSortable: true
        };
    }

    getOperationPrice() {
        return {
            key: 'operationPrice',
            icon: <FaDollarSign />,
            label: 'Montant',
            type: 'number',
            isSortable: true
        };
    }

}
